<template>
  <a-row class="project-table-header">
    <a-col class="project-table-item__number-col">Номер</a-col>
    <a-col class="project-table-item__datetime-col">Дата</a-col>
    <a-col class="project-table-item__partner-col">Партнер</a-col>
    <a-col class="project-table-item__name-col">Название проекта</a-col>
    <a-col class="project-table-item__status-col">Статус</a-col>
  </a-row>
</template>

<script setup></script>

<style lang="scss" scoped>
  @use '@/assets/styles/_colors.scss' as *;
  @use '@/components/projects/components/project-table-item.scss';
  $color-text-secondary-grey-216: #718096;

  .project-table-header {
    gap: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    border-bottom: 1px solid $color-bg-secondary-grey;

    color: $color-text-secondary-grey-216;
    font-variant-numeric: slashed-zero;
    font-family: Nunito Sans, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;

    padding: 40px 15px 10px 15px;
    margin-bottom: 10px;
  }
</style>
